module.exports = __webpack_public_path__ + "img/favorite-active.bb9ab37f.svg";